import i18next from 'i18next';
import i18n from '../i18n';

i18next.init(i18n);

export default i18next;